import React from 'react';
import { Helmet } from 'react-helmet';

const MaintenancePage = ({ message }) => {
  return (
    <>
      <Helmet>
        <title>Maintenance - Roomwork.ai</title>
      </Helmet>
      <div className="min-h-screen bg-background flex items-center justify-center px-4">
        <div className="text-center max-w-md">
          {/* Icon */}
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-warning/10 flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="text-warning"
            >
              <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
            </svg>
          </div>

          {/* Title */}
          <h1 className="text-2xl font-bold text-foreground mb-3">
            We're Under Maintenance
          </h1>

          {/* Message */}
          <p className="text-muted-foreground mb-8 leading-relaxed">
            {message || "We're currently performing scheduled maintenance to improve your experience. Please check back shortly. We apologize for any inconvenience."}
          </p>

          {/* Status badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-warning/10 text-warning text-sm font-medium">
            <span className="w-2 h-2 rounded-full bg-warning animate-pulse" />
            Maintenance in progress
          </div>
        </div>
      </div>
    </>
  );
};

export default MaintenancePage;
